import { useNavigate, useLocation } from "react-router-dom";
import {
  Users,
  DollarSign,
  Send,
  BookOpen,
  Settings as SettingsIcon,
  CheckCircle2,
} from "lucide-react";

const NAV_ITEMS = [
  { key: "employees", label: "Employees", icon: Users, path: "/" },
  { key: "pay-runs", label: "Pay Runs", icon: DollarSign, path: "/pay-runs" },
  { key: "filing", label: "Filing", icon: Send, path: "/filing" },
  { key: "reports", label: "Reports", icon: BookOpen, path: "/reports" },
  { key: "settings", label: "Settings", icon: SettingsIcon, path: "/settings" },
  { key: "approval", label: "Approval", icon: CheckCircle2, path: "/approval" },
];

export const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path) =>
    path === "/" ? location.pathname === "/" : location.pathname.startsWith(path);

  return (
    <aside className="w-60 shrink-0 bg-[#1e2d38] flex flex-col" data-testid="app-sidebar">
      <nav className="flex flex-col py-6 gap-1">
        {NAV_ITEMS.map(({ key, label, icon: Icon, path }) => {
          const active = isActive(path);
          return (
            <button
              key={key}
              onClick={() => navigate(path)}
              data-testid={`nav-${key}`}
              className={`group relative flex items-center gap-3 px-6 py-3 text-[15px] font-medium transition-colors ${
                active ? "text-[#13B5EA]" : "text-slate-300 hover:text-white hover:bg-white/5"
              }`}
            >
              <span
                className={`absolute left-0 top-0 h-full w-1 rounded-r bg-[#13B5EA] transition-opacity ${
                  active ? "opacity-100" : "opacity-0"
                }`}
              />
              <Icon
                size={20}
                className={active ? "text-[#13B5EA]" : "text-slate-400 group-hover:text-white"}
              />
              {label}
            </button>
          );
        })}
      </nav>
    </aside>
  );
};
